const newsRouter = [
  {
    path: '/news',
    name: 'NewsIndex',
    component: () => import('@/views/news/index')
  },
  {
    path: '/news/:id(\\d+)',
    name: 'NewsDetail',
    component: () => import('@/views/news/detail')
  }
]

export default newsRouter



// WEBPACK FOOTER //
// ./src/router/modules/news.js